var exports = {
  "kL": "x127c5a35--725e70--container",
  "Uo": "x127c5a35--725e70--buttons",
};

module.exports = exports;
